// Mirror of C# enum CloudX.Contracts.Enums.OtherSoftware — keep in sync.
export const OtherSoftware = {
  ClearFacts: 1,
  Bizzcontrol: 2,
  BillToBox: 3,
  Silverfin: 4,
  FiscaalGemak: 5,
  Caseware: 6,
  Nextens: 7,
  FiscaalOnline: 8,
  ExactJaarrekening: 9,
  Billit: 10,
  Furoo: 11,
  OkiOki: 12,
  NumNum: 13,
  Scrada: 14,
  Basecone: 15,
  Bouwsoft: 17,
  Breex: 18,
  Mollie: 20,
  Twikey: 21,
  ComaxMinFin: 22,
  TOGA: 23,
  Teamleader: 24,
  Twinntax: 25,
  Accounton: 26,
  Bothive: 27,
  Grub: 28,
  Dapas: 29,
  Zkr: 30,
  Facturalia: 31,
  Striktly: 32,
  Codabox: 33,
  Belcofin: 34,
  Eenvoudigfactureren: 36,
  OnFact: 37,
  Kassatellen: 38,
  Accountable: 39,
  Nmbrs: 40,
  Speedbooks: 41,
  Visionplanner: 42,
  Vectera: 43,
  Soda: 44,
  Cashaca: 45,
  Lightspeed: 47,
  Foodmaster: 48,
  Caro: 49,
  Factuursturen: 50,
  MFAS: 51,
  Audition: 52,
  Loket: 53,
  HIX: 54,
  Lucy: 56,
  WingsInvoice: 57,
  Carfac: 59,
  CEGID: 60,
  Roller: 61,
  Trivec: 62,
  WinBooksConnect: 63,
  Codaclean: 64,
  Bookzo: 65,
  Admisol: 66,
  Doccle: 67,
  Kleos: 68,
  Robaws: 69,
  Lyanthe: 70,
  ActaLibra: 71,
  Falco: 72,
  Continuans: 73,
  Monnize: 74,
  Edenred: 75,
  Pluxee: 76,
  BrightAnalytics: 77,
  Emasphere: 78,
  Employes: 79,
  Workiva: 80,
  AMLCare: 81,
  Anlisa: 82,
};

export const otherSoftwaresThatCanSync = [
  OtherSoftware.FiscaalGemak,
  OtherSoftware.Nextens,
  OtherSoftware.Dapas,
  OtherSoftware.Visionplanner,
  OtherSoftware.HIX,
];
